<template>
    <div class="toll-modal">
        <h3 class="map-modal__title">{{ title }}</h3>
        <div class="map-modal__content">{{ content }}</div>
    </div>
</template>
<script>
export default {
    props: {
        markerData: {
            default: () => {}
        }
    },

    data() {
        return {
            title: this.markerData.name,
            content: ""
        };
    }
};
</script>
